import { notification } from "antd";
import { RcFile } from "antd/lib/upload";

export const beforeUploadFileCheck = (singleFile: RcFile): boolean => {
    const extensionFromFileName: string = singleFile.name.split(".").pop();

    if (
        ["jpg", "jpeg", "png"].indexOf(extensionFromFileName?.toLowerCase()) < 0
    ) {
        notification["error"]({
            message: "Import Has Errors",
            description: `File ${singleFile.name} is not of a supported file type. Only jpg and png file types are supported.`,
            onClick: () => {
                notification.destroy();
            },
            duration: 0,
            style: { cursor: "pointer" },
        });
        return false;
    }

    return true;
};
